import { BookingSourcesLabels } from "@obby/constants";

export function Product_Source(product: any) {
  return BookingSourcesLabels[product.source];
}
